/* BSW Produktseite – Varianten, Galerie, Tabs */
(function () {
  if (customElements.get('bsw-product')) return;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '€{{amount_with_comma_separator}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    var m = format.match(placeholder);
    var value = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, '.', ',');
    }
    return format.replace(placeholder, value);
  }

  class BswProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      try { this.variants = JSON.parse(this.querySelector('script[data-variants]').textContent); } catch (e) { this.variants = []; }
      try { this.moneyFormat = JSON.parse(this.querySelector('script[data-money]').textContent); } catch (e) { this.moneyFormat = null; }
      this.ci = parseInt(this.dataset.colorIndex, 10);
      this.si = parseInt(this.dataset.sizeIndex, 10);
      this.onlyLeft = parseInt(this.dataset.onlyLeft, 10) || 10;

      this.groups = Array.prototype.slice.call(this.querySelectorAll('fieldset[data-opt-index]'));
      this.idInput = this.querySelector('[data-variant-id]');
      this.cta = this.querySelector('[data-cta]');
      this.mainImg = this.querySelector('[data-main-img]') || this.querySelector('.bsw-pdp__main img');
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));

      var self = this;
      this.groups.forEach(function (g) {
        g.addEventListener('change', function (e) {
          if (!e.target.matches('input[type="radio"]')) return;
          var idx = parseInt(g.dataset.optIndex, 10);
          self.update(idx === self.ci);
        });
      });

      this.thumbs.forEach(function (t) {
        t.addEventListener('click', function () { self.showMedia(t); });
      });

      var zoomBtn = this.querySelector('[data-zoom]');
      var dlg = this.querySelector('[data-zoom-dialog]');
      if (zoomBtn && dlg && this.mainImg) {
        zoomBtn.addEventListener('click', function () {
          var img = dlg.querySelector('[data-zoom-img]');
          var src = self.mainImg.currentSrc || self.mainImg.src;
          img.src = src.replace(/width=\d+/, 'width=2000');
          if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        });
        dlg.querySelector('[data-zoom-close]').addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      }

      this.initTabs();
      this.initGeo();
      this.update(false);
      this.initAlign();
    }

    // Desktop: Tabs (Beschreibung usw.) beginnen links auf Höhe des Warenkorb-Buttons
    initAlign() {
      var tabs = this.querySelector('.bsw-pdp__tabs');
      var cta = this.cta;
      if (!tabs || !cta || typeof ResizeObserver === 'undefined') return;
      var self = this;
      var mq = window.matchMedia('(min-width: 990px)');
      var raf = 0;
      var run = function () {
        tabs.style.marginTop = '';
        if (!mq.matches) return;
        var diff = cta.getBoundingClientRect().top - tabs.getBoundingClientRect().top;
        var zoom = parseFloat(getComputedStyle(self.closest('.bsw-pdp') || self).zoom) || 1;
        if (diff > 0) tabs.style.marginTop = Math.round(diff / zoom) + 'px';
      };
      var schedule = function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(run); };
      var ro = new ResizeObserver(schedule);
      ro.observe(this.querySelector('.bsw-pdp__gallery'));
      ro.observe(this.querySelector('.bsw-pdp__info'));
      if (mq.addEventListener) mq.addEventListener('change', schedule);
      window.addEventListener('load', schedule);
      schedule();
    }

    selected() {
      return this.groups.map(function (g) {
        var r = g.querySelector('input[type="radio"]:checked');
        return r ? r.value : null;
      });
    }

    match(v, sel, skip) {
      for (var i = 0; i < sel.length; i++) {
        if (i === skip || sel[i] === null) continue;
        if (v.o[i] !== sel[i]) return false;
      }
      return true;
    }

    money(c) { return formatMoney(c, this.moneyFormat); }

    update(colorChanged) {
      var self = this;
      var sel = this.selected();
      var complete = sel.every(function (x) { return x !== null; });
      var variant = complete ? this.variants.find(function (v) { return self.match(v, sel, -1); }) : null;

      // Verfügbarkeit je Option markieren (Farbe bleibt immer wählbar)
      this.groups.forEach(function (g) {
        var k = parseInt(g.dataset.optIndex, 10);
        g.querySelectorAll('input[type="radio"]').forEach(function (r) {
          var ok = self.variants.some(function (v) { return v.a && v.o[k] === r.value && self.match(v, sel, k); });
          var label = g.querySelector('label[for="' + r.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });

      // Farben: bei gewählter Größe verfügbare Farben deutlich markieren + Hinweis
      if (this.ci > -1) {
        var cg = this.querySelector('.bsw-pdp__opt--color');
        if (cg) {
          var sizeSel = this.si > -1 ? sel[this.si] : null;
          var colorHint = cg.querySelector('[data-color-hint]');
          if (!colorHint) {
            colorHint = document.createElement('p');
            colorHint.className = 'bsw-pdp__color-hint';
            colorHint.setAttribute('data-color-hint', '');
            colorHint.setAttribute('aria-live', 'polite');
            cg.appendChild(colorHint);
          }
          var total = 0, inStock = 0;
          cg.querySelectorAll('input[type="radio"]').forEach(function (r) {
            var label = cg.querySelector('label[for="' + r.id + '"]');
            if (!label) return;
            total++;
            var ok = !label.classList.contains('is-unavailable');
            if (ok) inStock++;
            label.classList.toggle('is-instock', !!sizeSel && ok);
            label.title = r.value + (sizeSel ? (ok ? ' – in Größe ' + sizeSel + ' verfügbar' : ' – in Größe ' + sizeSel + ' nicht verfügbar') : '');
          });
          if (sizeSel && total > 1) {
            colorHint.textContent = inStock === 0
              ? 'In Größe ' + sizeSel + ' ist aktuell keine Farbe verfügbar.'
              : 'In Größe ' + sizeSel + ' verfügbar: ' + inStock + ' von ' + total + ' Farben';
            colorHint.classList.toggle('is-none', inStock === 0);
            colorHint.hidden = false;
          } else {
            colorHint.hidden = true;
          }
        }
      }

      // Farbname
      if (this.ci > -1) {
        var cl = this.querySelector('[data-color-label]');
        if (cl && sel[this.ci]) cl.textContent = sel[this.ci];
      }

      // Preis (Variante oder erste passende)
      var ref = variant || this.variants.find(function (v) { return self.match(v, sel, -1); }) || this.variants[0];
      if (ref) {
        var pr = this.querySelector('[data-price]');
        var cp = this.querySelector('[data-compare]');
        var sv = this.querySelector('[data-saving]');
        if (pr) pr.textContent = this.money(ref.p);
        var sale = ref.c && ref.c > ref.p;
        if (cp) { cp.hidden = !sale; if (sale) cp.textContent = this.money(ref.c); }
        if (sv) { sv.hidden = !sale; if (sale) sv.querySelector('[data-saving-amount]').textContent = this.money(ref.c - ref.p); }
      }

      // Lagerstatus
      var stock = this.querySelector('[data-stock]');
      if (stock) {
        var state = 'in', text = this.dataset.textInStock || 'Auf Lager';
        if (variant) {
          if (!variant.a) { state = 'out'; text = 'Aktuell ausverkauft'; }
          else if (variant.q !== null && variant.q <= 0 && variant.b === 'continue') { state = 'low'; text = 'Auf Bestellung'; }
          else if (variant.q !== null && variant.q <= this.onlyLeft) { state = 'low'; text = 'Nur noch ' + variant.q + ' übrig'; }
        } else {
          var avail = this.variants.filter(function (v) { return v.a && self.match(v, sel, -1); });
          if (!avail.length) { state = 'out'; text = this.ci > -1 && sel[this.ci] ? 'In dieser Farbe ausverkauft – andere Farbe wählen' : 'Aktuell ausverkauft'; }
          else {
            var tracked = avail.every(function (v) { return v.q !== null; });
            var sum = avail.reduce(function (s, v) { return s + Math.max(0, v.q || 0); }, 0);
            if (tracked && sum > 0 && sum <= this.onlyLeft) { state = 'low'; text = 'Nur noch ' + sum + ' verfügbar'; }
          }
        }
        stock.dataset.state = state;
        stock.querySelector('[data-stock-text]').textContent = text;
      }

      // Warenkorb-Button
      var label = this.querySelector('[data-cta-label]');
      var selEl = this.querySelector('[data-cta-sel]');
      var hint = this.querySelector('[data-cta-hint]');
      var missing = this.groups.filter(function (g, i) { return sel[i] === null; })
        .map(function (g) { var l = g.querySelector('legend'); return l ? l.textContent.split(':')[0].trim() : ''; });
      if (this.cta) {
        if (!complete) {
          this.cta.disabled = true;
          if (label) label.textContent = 'In den Warenkorb';
          if (selEl) selEl.textContent = '';
          if (hint) hint.textContent = 'Bitte zuerst ' + (missing[0] || 'Variante') + ' wählen';
        } else if (!variant || !variant.a) {
          this.cta.disabled = true;
          if (label) label.textContent = 'Ausverkauft';
          if (selEl) selEl.textContent = '';
          if (hint) hint.textContent = 'Diese Kombination ist gerade nicht verfügbar. Ruf uns an – wir prüfen die Lieferzeit.';
        } else {
          this.cta.disabled = false;
          if (label) label.textContent = (variant.q !== null && variant.q <= 0 && variant.b === 'continue') ? 'Vorbestellen' : 'In den Warenkorb';
          var parts = [];
          if (this.si > -1) parts.push(sel[this.si]);
          if (this.ci > -1) parts.push(sel[this.ci]);
          if (selEl) selEl.textContent = parts.length ? '· ' + parts.join(' · ') : '';
          if (hint) hint.textContent = '';
        }
      }

      // Artikelnummer (SKU) der gewählten Variante
      var skuEl = this.querySelector('[data-sku]');
      if (skuEl) {
        var sku = variant && variant.s ? String(variant.s).trim() : '';
        skuEl.querySelector('[data-sku-value]').textContent = sku;
        skuEl.hidden = !sku;
      }

      // Formular + Leasing + URL
      if (variant) {
        if (this.idInput) this.idInput.value = variant.id;
        var leasing = this.querySelector('[data-leasing]');
        if (leasing) leasing.href = this.dataset.leasingBase + '&variant=' + variant.id + '#anfrage';
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }

      // Bild bei Farbwechsel
      if (colorChanged && this.ci > -1) {
        var withImg = variant && variant.m ? variant : this.variants.find(function (v) { return v.o[self.ci] === sel[self.ci] && v.m; });
        if (withImg) {
          var t = this.thumbs.find(function (x) { return String(x.dataset.mediaId) === String(withImg.m); });
          if (t) this.showMedia(t);
        }
      }
    }

    showMedia(t) {
      if (!this.mainImg) return;
      this.mainImg.src = t.dataset.src;
      if (t.dataset.srcset) this.mainImg.srcset = t.dataset.srcset; else this.mainImg.removeAttribute('srcset');
      this.thumbs.forEach(function (x) {
        var on = x === t;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    initTabs() {
      var tabs = Array.prototype.slice.call(this.querySelectorAll('[data-tab]'));
      var self = this;
      function activate(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = self.querySelector('[data-panel="' + t.dataset.tab + '"]');
          if (p) p.hidden = !on;
        });
      }
      tabs.forEach(function (t, i) {
        t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
        t.addEventListener('click', function () { activate(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          n.focus(); activate(n);
        });
      });
    }

    initGeo() {
      var target = this.querySelector('[data-geo-target]');
      if (!target) return;
      var body = this.querySelector('dialog[id$="-gf-dialog"] .gf-dlg-body, dialog[id$="-dialog"] .gf-dlg-body');
      if (!body) { target.textContent = 'Die Geometrie findest du im Größenrechner oben („Geometrie ansehen“).'; return; }
      var clone = body.cloneNode(true);
      clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      target.appendChild(clone);
    }
  }

  customElements.define('bsw-product', BswProduct);
})();
